import { gql } from "@apollo/client";

export const SUGGEST_EXTENSION_BOOKING_PRICE = gql`
  query suggestExtensionPrice($startDate: String!, $endDate: String!, $bookingId: String!) {
    suggestExtensionPrice(startDate: $startDate, endDate: $endDate, bookingId: $bookingId){
      vehicleGroup
      suggestedPrice
    }
  }
`;